module.exports = {"511523100":"江安镇","511523101":"红桥镇","511523102":"桐梓镇","511523103":"井口镇","511523104":"怡乐镇","511523105":"留耕镇","511523106":"底蓬镇","511523108":"五矿镇","511523109":"迎安镇","511523110":"夕佳山镇","511523111":"水清镇","511523112":"铁清镇","511523113":"四面山镇","511523114":"大井镇","511523115":"阳春镇","511523200":"大妙乡","511523203":"蟠龙乡","511523205":"仁和乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511523.json
// module id = 2175
// module chunks = 0